import styled from 'styled-components'

export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
`

export const Modal = styled.div`
  max-width: 505px;
  width: 100%;
  height: min-content;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => `rgb(${theme.background.modal})`};
  border-radius: 16px;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.15));
  @media (min-width: 1440px) {
    max-width: 570px;
  }

  @media (max-width: 538px) {
    width: 90%;
  }
`

export const Container = styled.div`
  width: 95%;
  height: 95%;
  display: flex;
  align-items: center;
  gap: 2rem;
  justify-content: center;
  flex-direction: column;

  p {
    margin: 0;
  }

  .closeModalIcon {
    font-size: 28px;
  }

  .CloseModal {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    color: #394a64;

    h2 {
      margin: 0.8rem 0;
    }
  }
`

export const WrapperPaymentForm = styled.div`
  width: 100%;
  margin: 0.875rem 0rem;

  form {
    padding: 1.875rem;
    max-width: 500px;
    border-radius: 8px;
    border: 1px solid rgb(51, 51, 51);
  }

  label {
    font-size: 0.9rem;
    font-weight: 700;
  }

  button {
    background: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.high})`};

    border: none;
    border-radius: 4px;
    padding: 0.7rem 1rem;

    margin: 0.5rem 0px 0.5rem auto;
    display: block;

    font-size: 0.8rem;
    line-height: 1.375rem;
    font-weight: 700;

    &:disabled {
      background: ${({ theme }) => `rgba(${theme.primary.base}, 0.5)`};
      cursor: not-allowed;
    }
  }
`

export const InputWrapper = styled.div`
  @media only screen and (min-width: 900px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`
